import BaseStore from './BaseStore'

class UserStore extends BaseStore {

	initialize() {
		this.logged_in = false;
		this.name = "";
	}

	isLoggedIn() {
		return this.logged_in;
	}

	getName() {
		return this.name;
	}

	emitUserState() {
		this.emit("UPDATE_USER_STATE", {
			logged_in: this.logged_in,
			name: this.name
		});
	}


	rehydrate(state) {
		this.logged_in = state.logged_in;
		this.name = state.name;
	}

	dehydrate() {
		return {
			logged_in: this.logged_in,
			name: this.name
		};
	}

	handleUserLogin(payload) {
		this.logged_in = true;
		this.name = payload.name;
		this.emitUserState();
	}
	handleUserNotLogin() {
		this.logged_in = false;
		this.name = "";
		this.emitUserState();
	}

}

UserStore.storeName = "UserStore";
UserStore.handlers = {
	'USER_LOGGED_IN': 'handleUserLogin',
	'USER_NOT_LOGGED_IN': 'handleUserNotLogin'
};

export default UserStore;